import PropTypes from 'prop-types'
import React from 'react'

import s from './Tooltip.module.scss'

export default function TooltipContent({ title, text }) {
  return (
    <>
      {title && <div className={s.title}>{title}</div>}
      {text && <div className={s.text} dangerouslySetInnerHTML={{ __html: text }} />}
    </>
  )
}

TooltipContent.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}
